// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-and-box_wrapper__fG8-J","box":"wrapper-and-box_box__FuKWo"};